export default __webpack_public_path__ + "static/media/DeleteWhiteIcon.a6568a34.svg";